module.exports = __webpack_public_path__ + "static/toggles-sketch@2x-81c6a11afbef98b2a5b67307961fa820.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/pop/sketches/toggles-sketch@2x.png
// module id = 931
// module chunks = 173944852332284 271422636699454